import { render, staticRenderFns } from "./collector-allocate-preview.vue?vue&type=template&id=c681de1e&scoped=true"
import script from "./collector-allocate-preview.vue?vue&type=script&lang=ts"
export * from "./collector-allocate-preview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c681de1e",
  null
  
)

export default component.exports